module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAbCAYAAAB1NA+iAAABPUlEQVQ4jZ2VPyhFURzHvwyUQUr5U3oDg4VktFAGNlksb1FmpUwy2t8qi4l6BqvBYJDJYLDYUCwMEoNIz0c/zs2vl/fe/d1T39u595zPp3Pu/Z1uG6ACrUfSoaQPmSCYEeCG3/YZhceBtwTfAqUIPMdfOwe6f7afE15y8IkfywOvOXivfrwVXHFw5b85zeAdB282mtcIPnLwcrNV1j/oAM4cvNDqHfmbfuAqga/AVJ4vlHWGgfsEPwKjeevDLrPAS4KtQPoi1WmHKTtND5IGo+eqXdJK6g9I2g8fzLSUGaCWtnEBdEXeQZZJ4DlJ7GuUogLLEHCXJE/AWFRg6QUuk+QdmI4Ksoo8dhVZjgqyVJ1kvYjAsu0kW0UElg0n2S0isKw6yUERgWXRSU6BzqjAMg98Jcl10T/ThKSqpNo3lBiiY9fKyEkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goback_white.png
// module id = 04n8
// module chunks = 1